//其他基本数据接口
import request from '@/utils/request'



//登录接口
export function login(data) {
  return request({
    url: '/visualization/common/token',
    method: 'post',
    data: data
  })
}

// 短信验证码登录
export function smsLogin(data) {
    return request({
        url: '/visualization/common/smsLogin',
        method: 'post',
        data: data
    })
}


//忘记密码
export function resetPassword(data) {
  return request({
    url: '/forgotPassword',
    method: 'post',
    data: data
  })
}
//换绑手机号
export function changePhone(data) {
  return request({
    url: '/changePhone',
    method: 'post',
    data: data
  })
}

// forgotPassword

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}


// 发送短信验证码
export function sendSmsCode(data) {
  return request({
    url: '/sms/sendCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}
//浏览次数接口
export function getServiceNum(query) {
  return request({
    url: '/system/config/configKeyNotoken/serviceNum',
    method: 'get',
    params: query
  })
}

//交易成功次数接口
export function getTransactionNum(query) {
  return request({
    url: '/system/config/configKeyNotoken/transactionNum',
    method: 'get',
    params: query
  })
}

// 查询资质信息列表
export function listParentQualification(query) {
  return request({
    url: '/base/parentQualification/allList',
    method: 'get',
    params: query
  })
}

//查询资质主节点

export function listParentMainNodes(query) {
  return request({
    url: '/base/parentQualification/mainNodes',
    method: 'get',
    params: query
  })
}


// 查询股权转让信息列表
export function getQualificationInfoList(query) {
  return request({
    url: '/visualization/corporate/list',
    method: 'get',
    params: query
  })
}

//发布股权转让信息
export function adddQualificationInfo(data) {
  return request({
    url: '/visualization/corporate/messageAdd',
    method: 'post',
    data: data
  })
}

//重新发布股权转让信息
export function republishQualificationInfo(data) {
  return request({
    url: '/visualization/corporate/republish',
    method: 'post',
    data: data
  })
}

// 查询资质信息列表
export function listQualificationInfo(query) {
  return request({
    url: '/visualization/qualification/list',
    method: 'get',
    params: query
  })
}

//详细（股权转让）
export function getQualificationInfoDetail(query) {
  return request({
    url: '/visualization/corporate/getInfo',
    method: 'get',
    params: query
  })
}

//用户个人信息查询
export function getUserDetail(query) {
  return request({
    url: '/visualization/common/user/info',
    method: 'get',
    params: query
  })
}

//获取发布人信息（带企业）
export function getPublisherInfo(query) {
  return request({
    url: '/visualization/common/publisherInfo',
    method: 'get',
    params: query
  })
}

//登录用户信息查询
export function getSelfDetail(query) {
  return request({
    url: '/visualization/common/user/current',
    method: 'get',
    params: query
  })
}
//用户信息修改
export function updateSelf(data) {
  return request({
    url: '/visualization/common/user/update',
    method: 'post',
    data: data
  })
}

//详细（技术负责人）
export function getTechnicalLeadInfoDetail(query) {
  return request({
    url: '/visualization/technicalLead/getInfo',
    method: 'get',
    params: query
  })
}


//详细（注册师）
export function getRegisterEngineerDetail(query) {
  return request({
    url: '/visualization/registerEngineer/getInfo',
    method: 'get',
    params: query
  })
}


//查询是否关注了这个用户
export function getIsFollowed(data) {
  return request({
    url: '/visualization/common/isFollowed',
    method: 'post',
    data: data
  })
}

//关注接口
export function followedSome(data) {
  return request({
    url: '/visualization/common/follow',
    method: 'post',
    data: data
  })
}

//取消关注接口
export function unfollowedSome(data) {
  return request({
    url: '/visualization/common/unfollow',
    method: 'post',
    data: data
  })
}


//查询资质类别
export function getQualificationCategories(query) {
  return request({
    url: '/visualization/qualification/categories',
    method: 'get',
    params: query
  })
}

//发布技术负责人信息
export function adddTechnicalLeadInfo(data) {
  return request({
    url: '/visualization/technicalLead/messageAdd',
    method: 'post',
    data: data
  })
}

//重新发布技术负责人信息
export function rePublishTechnicalLeadInfo(data) {
  return request({
    url: '/visualization/technicalLead/rePublish',
    method: 'post',
    data: data
  })
}



// 查询技术负责人信息列表
export function getTechnicalLeadList(query) {
  return request({
    url: '/visualization/technicalLead/list',
    method: 'get',
    params: query
  })
}

//查询注册师信息列表
export function getRegisterEngineerList(query) {
  return request({
    url: '/visualization/registerEngineer/list',
    method: 'get',
    params: query
  })
}

//发布注册师信息
export function addRegisterEngineerInfo(data) {
  return request({
    url: '/visualization/registerEngineer/messageAdd',
    method: 'post',
    data: data
  })
}

//重新发布注册师信息
export function rePublishRegisterEngineerInfo(data) {
  return request({
    url: '/visualization/registerEngineer/rePublish',
    method: 'post',
    data: data
  })
}






//************************************ */

// 新增企业认证信息
export function addEnterpriseAuth(data) {
  return request({
    url: '/visualization/common/enterpriseAuth/add',
    method: 'post',
    data: data
  })
}



// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data
  })
}


//根据手机号查询用户信息
export function searchUserPhone(query) {
  return request({
    url: '/visualization/common/user/search/byPhone',
    method: 'get',
    params  : query
  })
}

//授权接口
export function autoParent(data) {
  return request({
    url: '/visualization/common/enterpriseAuthorization/autoParent',
    method: 'post',
    data  : data
  })
}

//授权列表
export function authonsUser(query) {
  return request({
    url: '/visualization/common/enterpriseAuthorization/users',
    method: 'get',
    params:query
  })
}

//撤销授权
export function cancleAuthUser(data) {
  return request({
    url: '/visualization/common/enterpriseAuthorization/users/cancel',
    method: 'post',
    data:data
  })
}

//发布记录--股权转让
export function pubCorList(query) {
  return request({
    url: '/visualization/corporate/currentUserList',
    method: 'get',
    params:query
  })
}

//发布记录--技术负责人
export function pubTechnicalLeadList(query) {
  return request({
    url: '/visualization/technicalLead/currentUserList',
    method: 'get',
    params:query
  })
}

//发布记录--注册师
export function pubRegisterEngineerList(query) {
  return request({
    url: '/visualization/registerEngineer/currentUserList',
    method: 'get',
    params:query
  })
}


//发布记录--求购市场
export function pubPurchaseList(query) {
  return request({
    url: '/visualization/demand/currentUserList',
    method: 'get',
    params:query
  })
}

//个人中心--积分加投
export function addPonits(data) {
  return request({
    url: '/visualization/common/points/add',
    method: 'post',
    data:data
  })
}

//个人中心--续期
export function addTimes(data) {
  return request({
    url: '/visualization/common/renew/business',
    method: 'post',
    data:data
  })
}


//个人中心--股权转让状态完成/交易、未交易修改
export function updateCorporate(data) {
  return request({
    url: '/visualization/corporate/updateStatus',
    method: 'post',
    data:data
  })
}


//个人中心--技术负责人状态完成/交易、未交易修改
export function updateTechnicalLead(data) {
  return request({
    url: '/visualization/technicalLead/updateStatus',
    method: 'post',
    data:data
  })
}

//个人中心--注册师状态完成/交易、未交易修改
export function updateRegisterEngineer(data) {
  return request({
    url: '/visualization/registerEngineer/updateStatus',
    method: 'post',
    data:data
  })
}

//个人中心--求购市场状态完成/交易、未交易修改
export function updatePurchase(data) {
  return request({
    url: '/visualization/demand/updateStatus',
    method: 'post',
    data:data
  })
}


//预览前的操作
export function checkBeforeBrowse(data) {
  return request({
    url: '/visualization/common/verify/beforeBrowse',
    method: 'post',
    data:data
  })
}


//股权转让历史浏览记录
export function getMyCorporateViewLogs(query) {
  return request({
    url: '/visualization/corporate/myViewLogs',
    method: 'get',
    params:query
  })
}

//技术负责人历史浏览记录
export function getMyTechnicalLeadViewLogs(query) {
  return request({
    url: '/visualization/technicalLead/myViewLogs',
    method: 'get',
    params:query
  })
}

//注册师历史浏览记录
export function getMyRegisterEngineerViewLogs(query) {
  return request({
    url: '/visualization/registerEngineer/myViewLogs',
    method: 'get',
    params:query
  })
}

//求购市场历史浏览记录
export function getMyPurchaseViewLogs(query) {
  return request({
    url: '/visualization/demand/myViewLogs',
    method: 'get',
    params:query
  })
}



// 查询商品（积分套餐等）列表
export function listPointProduct(query) {
  return request({
    url: '/base/pointProduct/list',
    method: 'get',
    params: query
  })
}


// 查询当前用户积分入账情况
export function getPointComes(query) {
  return request({
    url: '/visualization/common/pointsCome/records',
    method: 'get',
    params: query
  })
}


// 查询当前用户积分消耗情况
export function getPointsOut(query) {
  return request({
    url: '/visualization/common/pointsOut/records',
    method: 'get',
    params: query
  })
}


//积分派发
export function pointDistribute(data) {
  return request({
    url: '/visualization/common/points/distribute',
    method: 'post',
    data: data
  })
}

//积分派发相关查询
export function getAuthorizedUser(query) {
  return request({
    url: '/visualization/common/points/authorizedUser',
    method: 'get',
    params: query
  })
}





//推荐记录
export function getRecommendRecords(query) {
  return request({
    url: '/visualization/common/recommend/records',
    method: 'get',
    params: query
  })
}

//推荐记录
export function getRecommendStatistics(query) {
  return request({
    url: '/visualization/common/recommend/statistics',
    method: 'get',
    params: query
  })
}

//积分提取记录
export function pointExtract(data) {
  return request({
    url: '/visualization/common/points/extract',
    method: 'post',
    data: data
  })
}

//股权转让我的收藏
export function getmyCorporateFavorites(query) {
  return request({
    url: '/visualization/corporate/myFavorites',
    method: 'get',
    params: query
  })
}

//注册师 我的收藏
export function getmyRegisterEngineerFavorites(query) {
  return request({
    url: '/visualization/registerEngineer/myFavorites',
    method: 'get',
    params: query
  })
}

//技术负责人 我的收藏
export function getmyTechnicalLeadFavorites(query) {
  return request({
    url: '/visualization/technicalLead/myFavorites',
    method: 'get',
    params: query
  })
}

//个人 我的收藏
export function getmyUserFavorites(query) {
  return request({
    url: '/visualization/common/myUserFavorites',
    method: 'get',
    params: query
  })
}

//求购市场 我的收藏
export function getmyPurchaseFavorites(query) {
  return request({
    url: '/visualization/demand/myFavorites',
    method: 'get',
    params: query
  })
}


//获取查看积分和剩余积分
export function getBrowsePointsInfo(query) {
  return request({
    url: '/visualization/common/getBrowsePointsInfo',
    method: 'get',
    params: query
  })
}




//生成订单
export function addOrder(data) {
  return request({
    url: '/visualization/common/order/generate',
    method: 'post',
    data: data
  })
}



//完成支付
export function paySuccess(data) {
  return request({
    url: '/visualization/common/pay/success',
    method: 'post',
    data: data
  })
}


//查询订单状态
export function getOrderStatus(data) {
  return request({
    url: '/visualization/common/order/detail',
    method: 'post',
    data: data
  })
}


//求购市场  新增
export function addDemand(data) {
  return request({
    url: '/visualization/demand/messageAdd',
    method: 'post',
    data: data
  })
}

//查询求购市场列表
export function getDemandList(query) {
  return request({
    url: '/visualization/demand/list',
    method: 'get',
    params: query
  })
}

//查询求购详情
export function getPurchaseInfoDetail(query) {
  return request({
    url: '/visualization/demand/getInfo',
    method: 'get',
    params: query
  })
}

//资质代办新增
export function addServices(data) {
  return request({
    url: '/visualization/services/messageAdd',
    method: 'post',
    data: data
  })
}

//资质代办列表
export function getServicesList(query) {
  return request({
    url: '/visualization/services/list',
    method: 'get',
    params: query
  })
}

//资质代办详情
export function getServicesDetail(query) {
  return request({
    url: '/visualization/services/getInfo',
    method: 'get',
    params: query
  })
}


//投标
export function bidDemand(data) {
  return request({
    url: '/visualization/demand/bid',
    method: 'post',
    data: data
  })
}


//查询投标列表

export function getBidRecords(query) {
  return request({
    url: '/visualization/demand/bidRecords',
    method: 'get',
    params: query
  })
}

// 查询被查看列表
export function getViewRecords(query) {
  return request({
    url: '/visualization/demand/viewRecords',
    method: 'get',
    params: query
  })
}


// 查询投标记录列表
export function listBidRecord(query) {
  return request({
    url: '/base/bidRecord/list',
    method: 'get',
    params: query
  })
}


// 查询访问记录列表
export function listViewLog(query) {
  return request({
    url: '/base/viewLog/list',
    method: 'get',
    params: query
  })
}


//重新发布求购信息
export function republishDemandInfo(data) {
  return request({
    url: '/visualization/demand/republish',
    method: 'post',
    data: data
  })
}

//当前用户的求购信息
export function getCurrentUserBidList(query) {
  return request({
    url: '/visualization/demand/currentUserBidList',
    method: 'get',
    params: query
  })
}


//给好友派发积分
export function pointFridDistribute(data) {
  return request({
    url: '/visualization/common/points/distribute/friend',
    method: 'post',
    data: data
  })
}

//好友积分派发记录列表
export function getFriendDistributeList(query) {
  return request({
    url: '/visualization/common/points/distribute/friend/list',
    method: 'get',
    params: query
  })
}




